import { render } from "./Addoffer.vue?vue&type=template&id=4dd45cae"
import script from "./Addoffer.vue?vue&type=script&lang=js"
export * from "./Addoffer.vue?vue&type=script&lang=js"

import "./Addoffer.vue?vue&type=style&index=0&id=4dd45cae&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__